import { render, staticRenderFns } from "./tree-edit.vue?vue&type=template&id=436d30ca&scoped=true"
import script from "./tree-edit.vue?vue&type=script&lang=js"
export * from "./tree-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d30ca",
  null
  
)

export default component.exports